import {IGridStatus} from '../../ap-interface/interfaces/ap-grid-status.interface';
import IGuid = System.IGuid;
import IPlantProtectionProduct = Data.BaseData.IPlantProtectionProduct;

export enum PlantProtectionGridActions {
  Active = 0,
  Inactive = 1
}

export interface IPlantProtectionProductsGridData {
  Id: IGuid;
  ProductName: string;
  StatusProduct: IGridStatus;
  StatusSelection: IGridStatus;
  Ingredients: string | undefined;
  StartDate: Date;
  EndDate: Date;
  UseByDate: Date;
  Crops: string;
  EffRange: string;
  DetailsTooltip: string;
  IsSystemProduct: boolean;
  SourceItem: IPlantProtectionProduct;
}
